import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { PrivacyService } from '../../../services/privacy/privacy.service';


@Component({
  selector: 'app-privacydialog',
  templateUrl: './privacydialog.component.html',
  styleUrls: ['./privacydialog.component.scss'],
  standalone: false
})
export class PrivacydialogComponent implements OnInit {
  @ViewChild('scrollableContent') scrollableContent!: ElementRef;
  isRead = false; // Checkbox for reading the privacy policy
  privacyNoticeContent = '';
  @Output() acknowledged = new EventEmitter<void>();
  constructor(private ref: DynamicDialogRef, private config: DynamicDialogConfig, private privacyService: PrivacyService) {}
  ngOnInit() {
    if (this.config?.data?.privacyNoticeContent) {
      this.privacyNoticeContent = this.config?.data?.privacyNoticeContent;
    } else {
      this.loadContent(this.config?.data?.selectedLanguage ? this.config?.data?.selectedLanguage : 'EN');
    }
  }

  loadContent(lang: string) {
    this.privacyService.loadPrivacyNoticeDialogContent(lang).subscribe((content) => {
      this.privacyNoticeContent = content;
    });
  }
  // Method to handle the acknowledgment
  onAcknowledge() {
    if (this.isRead) {
      this.acknowledged.emit(); // Emit the acknowledgment event
      this.ref.close(true); // Close the dialog
    } else {
      this.ref.close(false);
    }
  }
  onClose() {
    this.ref.close(false);
  }
}
